import PropTypes from 'prop-types';

import Container from './components/Container';
import { validate } from './utils/config';

const UpdateUserData = ({ config, delayBeforeDisplay, onUpdate, onCancel }) => {
  validate(config);

  return (
    <Container
      config={config}
      delayBeforeDisplay={delayBeforeDisplay}
      onUpdate={onUpdate}
      onCancel={onCancel}
    />
  );
};

UpdateUserData.propTypes = {
  config: PropTypes.object.isRequired,
  delayBeforeDisplay: PropTypes.number,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
};

export default UpdateUserData;
